import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const rupiah = (n) => `Rp ${Number(n).toLocaleString("id-ID")}`;

export const photoSrc = (url) =>
  url?.startsWith("/api/") ? `${BACKEND_URL}${url}` : url;
